import { IAmount } from "./amount";
export { IAmount };

export const FEETYPE_PIN_REQUEST = "KA-PIN-ABR";
export const FEETYPE_AIRBAG = "KA-BKAIRERST";
export const FEETYPE_REISSUE_CARD = "KA-KAR-NACHB";

export interface IFee {
    currency: string;
    description: string;
    fee: IAmount;
    feeId: string;

    // Service provided for this fee. E.g. "KA-PIN-NACHB" for new PIN
    feeType: string;
}

export interface ICardFeeResult {
    fees: Array<IFee>;
}


// WEBPACK FOOTER //
// ./src/types/fee.ts